import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fmtdia',
  templateUrl: './fmtdia.component.html',
  styleUrls: ['./fmtdia.component.scss']
})
export class FmtdiaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
